// @ts-expect-error [MIGRATION-SUPPRESSION]: TS1484
import languages, { boxLanguages } from '@box/languages';
import has from 'lodash/has';
import get from 'lodash/get';
import indexOf from 'lodash/indexOf';
import isArray from 'lodash/isArray';
import find from 'lodash/find';

declare let navigator: Navigator & {
  browserLanguage: string;
  systemLanguage: string;
  userLanguage: string;
};

// Box supported languages are BCP 47 tags, but browser locale may be BCP 47 tag or CLDR tag
// E.g. In Chrome, Japanese is 'ja', but we need to convert to Box-supported 'ja-JP'
// Set up a mapping so that browser locale can be converted to BCP 47 tag
const mapLocalesToBcp47Tags = () => {
  /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
  const localeMap: Record<string, any> = {};
  Object.keys(boxLanguages).forEach(bcp47Tag => {
    localeMap[bcp47Tag] = bcp47Tag;

    // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2532
    if (!has(localeMap, boxLanguages[bcp47Tag].cldrTag)) {
      // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2532
      localeMap[boxLanguages[bcp47Tag].cldrTag] = bcp47Tag;
    }
  });
  return localeMap;
};

const localeToBcp47Tag = mapLocalesToBcp47Tags();

const resolveLocaleToBcp47Tag = (locale: string) =>
  get(localeToBcp47Tag, locale);

const isSupportedLocale = (locale: string) =>
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2693
  indexOf(languages, resolveLocaleToBcp47Tag(locale)) >= 0;

export default () => {
  let locale;
  if (isArray(navigator.languages)) {
    // chrome and firefox
    locale = find(navigator.languages, loc => loc && isSupportedLocale(loc));
  }

  locale =
    locale ||
    find(
      [
        navigator.browserLanguage, // IE deprecated
        navigator.systemLanguage, // IE
        navigator.userLanguage, // IE
        navigator.language, // all browsers
      ],
      loc => loc && isSupportedLocale(loc),
    ) ||
    'en-US';
  return resolveLocaleToBcp47Tag(locale);
};
